module.exports = __webpack_public_path__ + "img/AI智能路灯.d2186f48.jpg";